/**
 * Lo que se ve en /estadisticas mientras llega el chunk diferido del dashboard.
 *
 * Pinta la misma Card y la misma cabecera que el dashboard, con el loader
 * dentro: al entrar, el título está desde el primer fotograma y lo único que
 * cambia al llegar el chunk es el contenido de debajo del divisor. Antes el
 * fallback era un spinner suelto sobre fondo vacío y la Card entera aparecía
 * de golpe.
 *
 * Los imports van por RUTA DIRECTA y no por los barrels del feature: este
 * fichero lo arrastra routes.js al chunk inicial, y el barrel de components
 * lleva a las secciones, que llevan a las gráficas, que llevan a recharts
 * (96,6 KiB gzip) — justo lo que la carga diferida saca de ahí.
 */

import React from "react";
import { Box, Card, CircularProgress, Divider } from "@mui/material";

import CabeceraDashboard from "../components/ui/CabeceraDashboard";
import { COLOR_ACENTO } from "../helpers/paleta";

/**
 * Alto del hueco del loader. Es una espera de red, no de datos: no intenta
 * adivinar el alto del dashboard (filtros + pestañas + sección varían), sólo
 * evita que la Card nazca aplastada y dé un salto brusco al llegar el chunk.
 */
const ALTURA_ESPERA = 320;

const DashboardEstadisticasCargando = () => (
    <Box id="estadisticas" sx={{ width: "100%" }}>
        <Card sx={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)", borderRadius: 2 }}>
            <CabeceraDashboard />

            <Divider sx={{ mx: 3 }} />

            <Box
                aria-busy="true"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: ALTURA_ESPERA,
                }}
            >
                <CircularProgress sx={{ color: COLOR_ACENTO }} />
            </Box>
        </Card>
    </Box>
);

export default DashboardEstadisticasCargando;
